import templateUrl from 'emun.report/quick-report-list.htm'
import controller from 'emun.report/quick-report-list.controller'
import 'emun.report/report.client.scss'

let QuickReportList = {
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default QuickReportList;